export const getBreadcrumbsOverrides = (theme, typography) => {
  return {
    MuiBreadcrumbs: {
      styleOverrides: {
        root: {
          color: theme.palette.secondary.dark,
          ...typography.body.caption,
          ".MuiBreadcrumbs-ol": {
            ".MuiBreadcrumbs-li": {
              "a.MuiTypography-root": {
                ...typography.body.caption,
                color: theme.palette.text.secondary
              },
              "span.MuiTypography-root": {
                ...typography.body.caption,
                color: theme.palette.primary.dark
              }
            }
          }
        },
        li: {
          marginLeft: 0
        }
      }
    }
  };
};